import { useContext } from "react";
import { ConfigContext } from "src/contexts/ConfigContext";

export const useConfig = () => useContext(ConfigContext);